<template>
    <div>
        <div class="table-a">
            <div class="table-name">
                <h3 class="ico_table_name">문서정보</h3>
            </div>
            <table class="table">
                <colgroup>
                    <col width="10%">
                    <col width="36%">
                    <col width="10%">
                    <col width="17%">
                    <col width="10%">
                    <col width="17%">
                </colgroup>
                <tbody>
                    <tr>
                        <th>제목</th>
                        <td>{{ form.docTitleNm }}</td>
                        <th>문서번호</th>
                        <td>{{form.apprNo}}</td>
                        <th>문서상태</th>
                        <td>{{form.docStatNm}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="table-b">
            <div class="table-name">
                <h3 class="ico_table_name">결재선</h3>
            </div>
            <table class="table">
                <colgroup>
                    <col width="3%">
                    <col width="7%">
                    <col width="20%">
                    <col width="20%">
                    <col width="8%">
                    <col width="12%">
                    <col width="30%">
                </colgroup>
                <thead>
                <tr>
                    <th class="no-radius">NO</th>
                    <th>결재유형</th>
                    <th>결재자</th>
                    <th>실제결재자</th>
                    <th>결재상태</th>
                    <th>결재일자</th>
                    <th style="border-right: 1px solid #adadad">의견</th>
                </tr>
                </thead>
                <tbody id="tbody">
                <tr v-for="(item, index) in form.apprDetailsData">
                    <td style="text-align: center;">{{index+1}}</td>
                    <td style="text-align: center;">{{item.apprType}}</td>
                    <td>{{item.aprverUser}} {{item.jobNm}} / {{item.deptNm}}</td>
                    <td>{{item.aaprverUser}}</td>
                    <td style="text-align: center;">{{item.apprStatus}}</td>
                    <td style="text-align: center;">{{item.apprDtm}}</td>
                    <td style="border-right: 1px solid #adadad">{{item.apprDesc}}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="table-a" v-if="form.apprRefersData.length>0">
            <table class="table">
                <colgroup>
                    <col width="10%">
                    <col width="90%">
                </colgroup>
                <tbody>
                <tr>
                    <th>참조자</th>
                    <td>
                        <span v-for="(item, index) in form.apprRefersData">
                            <span v-if="index!==0">,</span>{{item.referUser}}
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import mixin from '@/mixin';
    import mixinSlip from '@/mixin/slip';

    export default {
        name: 'ApprHeader',
        props: {
            'value': {
                type: Object,
                required: true
            },
            'apprHeader': {
                type: Object,
                required: false,
                default() {
                    return {}
                }
            },
            'apprLine': {
                type: Array,
                required: true
            },
            'referLine': {
                type: Array,
                required: true
            },
            docType: {
                type: String,
                required: false,
                default: 'SLIP'
            }
        },
        mixins: [mixin, mixinSlip],
        data() {
            return {
                form: {
                    apprDetailsData: [],
                    apprRefersData: [],
                    //문서유형
                    docType: '',
                    //문서번호
                    apprNo: '',
                    //문서상태
                    docStatNm: '',
                    //문서제목
                    docTitleNm: '',
                    //NO
                    apprSeq: '',
                    //결재유형
                    apprType: '',
                    //결재자
                    aprverUser: '',
                    //실제결재자
                    aaprverUser: '',
                    //결재상태
                    apprStatus: '',
                    //결재일자
                    apprDtm: '',
                    //의견
                    apprDesc: '',
                    apprSubYn: 'Y',
                },
                docTypes: [],
            };
        },
        methods: {
            getDocTypeCombo() {
                this.$http.get(`/api/code/combo`, {params: {groupCd: "VISIT_TYPE_CD"}})
                    .then(response => {
                        this.docTypes = response.data;
                    });
            },
            setApprHeader() {
                Object.assign(this.form, this.apprHeader[0]);
            },
            changeFormTitleEvent(value) {
                if (this.docType === 'SHORT') {
                    this.form.docType = '단기방문'
                    this.form.docTitleNm = value.visitorComp + ' / ' + value.purposeNm + ' / ' + value.staYmd + '~' + value.endYmd
                } else if (this.docType === 'LONG') {
                    this.form.docType = '장기방문'
                    this.form.docTitleNm = value.visitorComp + ' / ' + value.purposeNm + ' / ' + value.staYmd + '~' + value.endYmd
                }
            }
        },
        mounted() {
            this.getDocTypeCombo()
        },
        watch: {
            apprHeader(value) {
                this.form = this.apprHeader || {}
                this.form.apprSubYn = 'N'
                this.setApprHeader()
                // 바뀌었으니 이것도 같이 바꾸어준다
                this.changeFormTitleEvent(this.value)
            },
            apprLine(value) {
                this.form.apprDetailsData = value.map(x => {
                    x.apprDtm = x.apprDtm ? this.$moment(x.apprDtm.replace(/:/g, '')).format('YY-MM-DD HH:mm') : undefined
                    return x
                })
                this.$forceUpdate()
            },
            referLine(value) {
                this.form.apprRefersData = value.map(x => {
                    x.apprDtm = x.apprDtm ? this.$moment(x.apprDtm).format('YYYY-MM-DD') : undefined
                    return x
                })
                this.$forceUpdate()
            },
            'value': {
                immediate: true,
                deep: true,
                handler: 'changeFormTitleEvent'
            }
        }
    };
</script>

<style scoped>
    .table-a, .table-b {
        margin-bottom: 20px;
    }
    .table-a.fixed-th {
        margin-bottom: 10px;
    }
</style>

